import validate from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.30_db0@0.3.2_eslint@9.28.0_jiti@2.4.2__io_cmcg4xjaul5bu3dtxswzmemqoq/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.30_db0@0.3.2_eslint@9.28.0_jiti@2.4.2__io_cmcg4xjaul5bu3dtxswzmemqoq/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "default-ke-stazeni": () => import("/app/middleware/defaultKeStazeni.ts"),
  kim: () => import("/app/middleware/kim.ts"),
  "redirect-to-external-app": () => import("/app/middleware/redirectToExternalApp.ts")
}